// @ts-nocheck
import {
  ADD_ISSUE_FOR_POSITION_FAILURE,
  ADD_ISSUE_FOR_POSITION_REQUEST,
  ADD_ISSUE_FOR_POSITION_SUCCESS,
  DELETE_EVENT_MEDIA_FILE_FAILURE,
  DELETE_EVENT_MEDIA_FILE_REQUEST,
  DELETE_EVENT_MEDIA_FILE_SUCCESS,
  GET_ALL_MEDIA_FILES_FAILURE,
  GET_ALL_MEDIA_FILES_REQUEST,
  GET_ALL_MEDIA_FILES_SUCCESS,
  GET_EVENT_MEDIA_FILES_FAILURE,
  GET_EVENT_MEDIA_FILES_REQUEST,
  GET_EVENT_MEDIA_FILES_SUCCESS,
  GET_REPORTED_ISSUES_OF_POSITION_FAILURE,
  GET_REPORTED_ISSUES_OF_POSITION_REQUEST,
  GET_REPORTED_ISSUES_OF_POSITION_SUCCESS,
  SEND_ADMIN_RESPONSE_FOR_ISSUE_FAILURE,
  SEND_ADMIN_RESPONSE_FOR_ISSUE_REQUEST,
  SEND_ADMIN_RESPONSE_FOR_ISSUE_SUCCESS,
  UPLOAD_MEDIA_FILE_FAILURE,
  UPLOAD_MEDIA_FILE_REQUEST,
  UPLOAD_MEDIA_FILE_SUCCESS,
} from "../constants/reportedIssues";
import { GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_REQUEST } from "../constants/reportedIssues";
import { GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_SUCCESS } from "../constants/reportedIssues";
import { GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_FAILURE } from "../constants/reportedIssues";

const initialState = {
  sessionPositionsReportedIssues: {
    data: [],
    isRequestLoading: false,
  },
  addIssueInPosition: {
    isRequestLoading: false,
  },
  reportedIssuesByContractorId: {
    data: null,
    isRequestLoading: false,
  },
  sendAdminResponseReportedIssue: {
    isRequestLoading: false,
  },

  // event media
  mediaGallery: {
    allMedia: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    mediaLoading: false,
    uploadLoading: false,
  },

  // all media files
  allMediaGallery: {
    allMedia: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    mediaLoading: false,
    uploadLoading: false,
  },
};

const reportedIssuesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_ISSUES_OF_POSITION_REQUEST:
      return {
        ...state,
        sessionPositionsReportedIssues: {
          ...state?.sessionPositionsReportedIssues,
          isRequestLoading: true,
        },
      };

    case GET_REPORTED_ISSUES_OF_POSITION_SUCCESS: {
      const filteredSessionIdx =
        state?.sessionPositionsReportedIssues?.data?.findIndex((session) => {
          return session?.sessionId === action?.payload?.sessionId;
        });
      return {
        ...state,
        sessionPositionsReportedIssues: {
          ...state?.sessionPositionsReportedIssues,
          data:
            filteredSessionIdx >= 0
              ? state?.sessionPositionsReportedIssues?.data?.map?.(
                  (session) => {
                    if (session?.sessionId === action?.payload?.sessionId) {
                      const filteredPositionIdx =
                        session?.positionsReportedIssues?.findIndex(
                          (reportedIssue) => {
                            return (
                              reportedIssue?.positionId ===
                              action?.payload?.positionId
                            );
                          },
                        );
                      if (filteredPositionIdx < 0) {
                        return {
                          ...session,
                          positionsReportedIssues: [
                            ...session.positionsReportedIssues,
                            {
                              reportedIssues: action?.payload?.reportedIssues,
                              positionId: action?.payload?.positionId,
                            },
                          ],
                        };
                      } else {
                        return session;
                      }
                    } else {
                      return session;
                    }
                  },
                )
              : [
                  {
                    sessionId: action?.payload?.sessionId,
                    positionsReportedIssues: [
                      {
                        reportedIssues: action?.payload?.reportedIssues,
                        positionId: action?.payload?.positionId,
                      },
                    ],
                  },
                ],
          isRequestLoading: false,
        },
      };
    }

    case GET_REPORTED_ISSUES_OF_POSITION_FAILURE:
      return {
        ...state,
        sessionPositionsReportedIssues: {
          ...state?.sessionPositionsReportedIssues,
          isRequestLoading: false,
        },
      };

    // add issue in position...
    case ADD_ISSUE_FOR_POSITION_REQUEST:
      return {
        ...state,
        addIssueInPosition: {
          ...state?.addIssueInPosition,
          isRequestLoading: true,
        },
      };

    case ADD_ISSUE_FOR_POSITION_SUCCESS:
      return {
        ...state,
        addIssueInPosition: {
          ...state?.addIssueInPosition,
          isRequestLoading: false,
        },
      };

    case ADD_ISSUE_FOR_POSITION_FAILURE:
      return {
        ...state,
        addIssueInPosition: {
          ...state?.addIssueInPosition,
          isRequestLoading: false,
        },
      };

    case SEND_ADMIN_RESPONSE_FOR_ISSUE_REQUEST:
      return {
        ...state,
        sendAdminResponseReportedIssue: {
          isRequestLoading: true,
        },
      };

    case SEND_ADMIN_RESPONSE_FOR_ISSUE_SUCCESS:
      return {
        ...state,
        sendAdminResponseReportedIssue: {
          isRequestLoading: false,
        },
      };

    case SEND_ADMIN_RESPONSE_FOR_ISSUE_FAILURE:
      return {
        ...state,
        sendAdminResponseReportedIssue: {
          isRequestLoading: false,
        },
      };

    case GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_REQUEST:
      return {
        ...state,
        reportedIssuesByContractorId: {
          isRequestLoading: true,
        },
      };

    case GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_SUCCESS:
      return {
        ...state,
        reportedIssuesByContractorId: {
          data: action?.payload?.res,
          isRequestLoading: false,
        },
      };

    case GET_REPORTED_ISSUES_BY_CONTRACTOR_ID_FAILURE:
      return {
        ...state,
        reportedIssuesByContractorId: {
          data: null,
          isRequestLoading: false,
        },
      };

    // NOTE: media galaray
    case GET_EVENT_MEDIA_FILES_REQUEST:
      return {
        ...state,
        mediaGallery: {
          ...state?.mediaGallery,
          mediaLoading: true,
        },
      };

    case GET_EVENT_MEDIA_FILES_SUCCESS:
      return {
        ...state,
        mediaGallery: {
          allMedia: action?.payload?.data,
          currentPage: action?.payload?.currentPage,
          totalPages: action?.payload?.totalPages,
          totalCount: action?.payload?.totalCount,
          mediaLoading: false,
        },
      };

    case GET_EVENT_MEDIA_FILES_FAILURE:
      return {
        ...state,
        mediaGallery: {
          ...state?.mediaGallery,
          mediaLoading: false,
        },
      };

    // upload media file request
    case UPLOAD_MEDIA_FILE_REQUEST:
      return {
        ...state,
        mediaGallery: {
          ...state.mediaGallery,
          uploadLoading: true,
        },
      };
    case UPLOAD_MEDIA_FILE_FAILURE:
      return {
        ...state,
        mediaGallery: {
          ...state.mediaGallery,
          uploadLoading: false,
        },
      };
    case UPLOAD_MEDIA_FILE_SUCCESS:
      return {
        ...state,
        mediaGallery: {
          ...state.mediaGallery,
          uploadLoading: false,
        },
      };

    // delete media
    case DELETE_EVENT_MEDIA_FILE_REQUEST:
      return {
        ...state,
        mediaGallery: {
          ...state?.mediaGallery,
          mediaLoading: true,
        },
      };

    case DELETE_EVENT_MEDIA_FILE_SUCCESS:
      return {
        ...state,
        mediaGallery: {
          ...state?.mediaGallery,
          mediaLoading: false,
        },
      };

    case DELETE_EVENT_MEDIA_FILE_FAILURE:
      return {
        ...state,
        mediaGallery: {
          ...state?.mediaGallery,
          mediaLoading: false,
        },
      };

    // NOTE: all media  files
    case GET_ALL_MEDIA_FILES_REQUEST:
      return {
        ...state,
        allMediaGallery: {
          ...state?.allMediaGallery,
          mediaLoading: true,
        },
      };

    case GET_ALL_MEDIA_FILES_SUCCESS:
      return {
        ...state,
        allMediaGallery: {
          allMedia: action?.payload?.data,
          currentPage: action?.payload?.currentPage,
          totalPages: action?.payload?.totalPages,
          totalCount: action?.payload?.totalCount,
          mediaLoading: false,
        },
      };

    case GET_ALL_MEDIA_FILES_FAILURE:
      return {
        ...state,
        allMediaGallery: {
          ...state?.allMediaGallery,
          mediaLoading: false,
        },
      };

    default:
      return state;
  }
};

export default reportedIssuesReducer;
export { initialState };